import { useState } from 'react';

function OrgNode({ person, type='default', onSelect }) {
  return (
    <div className={`org-node ${type}`} onClick={() => onSelect(person)}>
      <div className="org-avatar">
        {person.photo_url ? <img src={person.photo_url} alt={person.name} /> : person.initials}
      </div>
      <div className="org-name">{person.name}</div>
      <div className="org-role">{person.role}</div>
    </div>
  );
}

export default function OrgChart({ people, departments, onSelectPerson }) {
  const [expanded, setExpanded] = useState({});
  const toggle = id => setExpanded(p => ({ ...p, [id]: !p[id] }));
  const ceo = people.find(p => p.role?.toLowerCase().includes('ceo'));
  const dg  = people.find(p => p.role?.toLowerCase().includes('directora general') || p.role?.toLowerCase().includes('director general'));
  const directors = departments.map(d => ({
    dept: d,
    person: people.find(p => p.department_id === d.id && p.is_director === 1)
  })).filter(x => x.person);

  return (
    <div className="org-wrap">
      <div className="org-bar"><span>Estructura organizativa · {departments.length} departamentos</span></div>
      <div className="org-canvas">
        <div className="org-tree">
          {ceo && <div className="org-row"><div className="org-branch"><OrgNode person={ceo} type="ceo" onSelect={onSelectPerson} /></div></div>}
          {ceo && dg && <div className="org-vline" />}
          {dg && <div className="org-row"><div className="org-branch"><OrgNode person={dg} type="dg" onSelect={onSelectPerson} /></div></div>}
          {directors.length > 0 && <div className="org-vline" />}
          <div className="org-row" style={{ alignItems:'flex-start', gap:8 }}>
            {directors.map(({ dept, person }) => {
              const team = (dept.people||[]).filter(p => p.id !== person.id);
              const isOpen = !!expanded[dept.id];
              return (
                <div key={dept.id} className="org-branch">
                  <OrgNode person={person} type="director" onSelect={onSelectPerson} />
                  {dept.subdepartments?.length > 0 && (
                    <><div className="org-vline" />
                    <div className="org-subnodes">
                      {dept.subdepartments.map(sub => (
                        <div key={sub.id} className="org-sub"><div className="sn">{sub.name}</div></div>
                      ))}
                    </div></>
                  )}
                  {team.length > 0 && (
                    <>
                      <button className="org-team-toggle" onClick={() => toggle(dept.id)}>
                        {isOpen ? '▲ Ocultar equipo' : `▼ Ver equipo (${team.length})`}
                      </button>
                      {isOpen && (
                        <div className="team-grid org-team-grid">
                          {team.map(p => (
                            <div key={p.id} className="team-member" onClick={() => onSelectPerson(p)}>
                              <div className="member-avatar">{p.photo_url?<img src={p.photo_url} alt={p.name}/>:p.initials}</div>
                              <div className="member-name">{p.name}</div>
                              <div className="member-role">{p.role}</div>
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div style={{ padding:'0 1rem 1rem' }}>
        <div className="org-legend">
          <div className="org-legend-item"><span className="org-legend-dot" style={{ background:'#2d2d2d' }} /> CEO</div>
          <div className="org-legend-item"><span className="org-legend-dot" style={{ background:'#E53812' }} /> Dir. General</div>
          <div className="org-legend-item"><span className="org-legend-dot" style={{ background:'#fff', border:'2px solid #E53812' }} /> Director/a Dpto.</div>
          <div className="org-legend-item"><span className="org-legend-dot" style={{ background:'#f5f5f5', border:'1px solid #e8e8e8' }} /> Subdpto.</div>
        </div>
      </div>
    </div>
  );
}
